<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" id="epigraph">
<div class="text" id="epigraph-text">
<p class="first first-in-chapter first-full-width"><i>‘Space plays a role in all our behaviour. We live in it, move through it, explore it, defend it. We find it easy enough to point to bits of it: the room, the mantle of the heavens, the gap between two fingers, the place left behind when the piano finally gets moved.’</i></p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width"><b>The Hippocampus as a Cognitive Map,</b></p>
<p class="subsq">O’Keefe and Nadel, 1978</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?04eecf6a